import { apiClient } from './client'
import endpoints from './endpoints'
import { unwrapVoid } from './normalize'

export default async function saveMetrics(payload) {
  const response = await apiClient.post(endpoints.metricEvents, payload)
  return unwrapVoid(response)
}

export async function saveVerificationMetric({
  metricEventId,
  isVerified,
  dataCollectionStatementId,
  userRole,
}) {
  const response = await apiClient.put(`${endpoints.metricEvents}/verification/${metricEventId}`, {
    userRole,
    dataCollectionStatementId,
    isVerified,
  })
  return unwrapVoid(response)
}

export async function saveMetricEventStatus({ metricEventId, metricEventStatusId }) {
  const response = await apiClient.put(`${endpoints.metricEvents}/${metricEventId}/status`, {
    metricEventStatusId,
  })
  return unwrapVoid(response)
}
